






































import Vue from 'vue';
import {API} from '@/api';
import { mapActions } from 'vuex';
import AgregarSerie from '@/components/series/AgregarSerie.vue';

export default Vue.extend({
  components: { AgregarSerie },
  data: () => ({
    singleSelect: false,
    row: {},
    Series: [],
    selected: [],
    headers: [
      { text: 'Serie', value: 'nombre' },
      { text: 'Ultimo Folio', value: 'ultimoFolioGenerado' },
    ],
    total: 0,
    loading: true,
    options: {},
    readonly: true,
  }),
/*  mounted() {
  },*/
  methods: {
    ...mapActions(['getSeriesList']),
    open(event) {
      console.log('Current:', event);
      this.Serie = event;
      this.readonly = true;
    },
    rowSelected(event) {
      this.open(event);
    },
    async loadData() {
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        this.loading = true;
        const result = await this.$store.dispatch('getSeriesList', {admin, condo});
        console.debug('getConceptoList result: %o', result);
        this.total = result.totalElements;
        this.Series = result;
        console.log('Series: %o', this.Series);
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadData();
    },
    async reloadGrid(event) {
      this.loadData();
    },
  },
});
